module.exports = __webpack_public_path__ + "img/deepseek.9f899b4e.svg";